export default __webpack_public_path__ + "static/media/swissimunity-wide@3x.e963071b.jpg";